import { useNavigate } from 'react-router-dom';
import styles from './DownloadBanner.module.css';

export default function DownloadBanner() {
  const navigate = useNavigate();

  return (
    <div className={styles.outer} onClick={() => navigate('/download')} role="button" tabIndex={0}>
      <div className={styles.text}>
        <p className={styles.title}>다잇, <br />모바일 앱 출시</p>
        <p className={styles.sub}>
          App Store · Google Play에서 지금 바로 만나보세요
        </p>
        <div className={styles.badgeRow}>
          <a
            href="https://apps.apple.com/kr/app/%EB%8B%A4%EC%9E%87/id6779888256"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appStoreBadge}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src="/Download_on_the_App_Store_Badge_KR_RGB_blk_100317.svg"
              alt="App Store에서 다운로드"
              className={styles.appStoreBadgeImg}
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.daeat.app&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appStoreBadge}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src="/GetItOnGooglePlay_Badge_Web_color_Korean.png"
              alt="Google Play에서 다운로드"
              className={styles.appStoreBadgeImg}
            />
          </a>
        </div>
      </div>
      <div className={styles.phones}>
        <img src="/recipe.png" alt="레시피" className={`${styles.phone} ${styles.phoneLeft}`} />
        <img src="/campaign.png" alt="체험단" className={`${styles.phone} ${styles.phoneCenter}`} />
        <img src="/feed.png" alt="피드" className={`${styles.phone} ${styles.phoneRight}`} />
      </div>
    </div>
  );
}
